import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CustomerStatusService} from 'app/blocks/service/api/customer-status.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ICustomerStatus} from 'app/blocks/model/customer-status.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {CustomerStatus} from 'app/blocks/model/customer-status.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class CustomerStatusResource extends AbstractEntityResource<ICustomerStatus> {
    constructor(customerStatusService: CustomerStatusService, router: Router) {
        super(
            Resource.CUSTOMER_STATUSES,
            customerStatusService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CUSTOMER_STATUSES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CUSTOMER_STATUSES),
            (entity?) => new CustomerStatus(entity),
            (entity) => entity.code
        );
    }
}
